import React, { useEffect, useState } from 'react';
import { useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil';
import NumberFormat from 'react-number-format';
import { activeModalType, ModalType } from '../state/modals';
import { fixtureGlobalIdLookupState } from '../state/openFixture';
import { modalEditorOpen } from '../state/modals';
import { getUnauthenticatedFixtures } from '../services/fosService';
import { FOSTable } from '../common/table/FOSTable';
import { FOSTableDateCell } from '../common/table/FOSTableDateCell';
import { FOSTableTooltipCell } from '../common/table/FOSTableTooltipCell';
import { FOSTableCurrencyCell } from '../common/table/FOSTableCurrencyCell';
import { FOSTableVesselLinkUnauthenticatedCell } from '../common/table/FOSTableVesselLinkUnauthenticatedCell';
import { Regions } from '../common/types';

enum Tab {
  Spot = 'spot',
  Term = 'term',
}

export const Fixtures = (props: any) => {
  const [fixturesLoaded, setFixturesLoaded] = useState(false);
  const [tab, setTab] = useState<Tab>(Tab.Spot);
  const [fixtures, setFixtures] = useState<any>([]);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [sortBy, setSortBy] = useState({ id: 'fixture_date', desc: true });

  const setFixtureGlobalId = useSetRecoilState(fixtureGlobalIdLookupState);
  const [moodalOpen, setModalOpen] = useRecoilState(modalEditorOpen);
  const setModalType = useSetRecoilState(activeModalType);

  const openFixture = (fixtureGlobalId: string) => {
    setFixtureGlobalId(fixtureGlobalId);
    setModalOpen(true);
    setModalType(ModalType.OpenFixture);
  };

  useEffect(() => {
    if (moodalOpen) {
      return;
    }

    getUnauthenticatedFixtures(page, perPage, sortBy, tab).then(
      (fixturesRes) => {
        setFixtures(fixturesRes.data);
        setTotalPages(fixturesRes.pagination.lastPage);
        setFixturesLoaded(true);
      },
      (reason) => {
        console.log('ERROR');
        setFixturesLoaded(true);
      }
    );
  }, [tab, moodalOpen, page, perPage, sortBy]);

  const resetPage = () => {
    setPage(1);
  };

  useEffect(() => {
    resetPage();
  }, [tab]);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Fixture Date',
        accessor: 'fixture_date',
        Cell: (cell: any) => (
          <FOSTableDateCell value={cell.value}></FOSTableDateCell>
        ),
      },
      {
        Header: 'Vessel Name',
        accessor: 'vessel_name',
        Cell: ({ row }: any) => (
          <FOSTableVesselLinkUnauthenticatedCell
            imo={row.original.imo}
            vesselName={row.original.vessel_name}
          ></FOSTableVesselLinkUnauthenticatedCell>
        ),
      },
      {
        Header: 'Charterer',
        accessor: 'charterer',
      },
      {
        Header: 'Rate',
        accessor: 'rate',
        disableSortBy: true,
        Cell: ({ cell, row }: any) =>
          row.original.rate_type_rnr ? (
            <div>RNR</div>
          ) : (
            <FOSTableCurrencyCell
              value={cell.value}
              currency={row.original.currency}
            ></FOSTableCurrencyCell>
          ),
      },
      {
        Header: 'Workscope',
        accessor: 'workscope',
        Cell: (cell: any) => (
          <FOSTableTooltipCell value={cell.value}></FOSTableTooltipCell>
        ),
      },
    ],
    []
  );

  return (
    <div>
      <div className='north-sea-spot-caption'>Fixtures</div>

      <ul className='nav nav-tabs'>
        <li className='nav-item'>
          <a
            className={tab === Tab.Spot ? 'nav-link active' : 'nav-link'}
            onClick={(e) => {
              setTab(Tab.Spot);
            }}
            aria-current='page'
            href='#1'
          >
            Spot
          </a>
        </li>
        <li className='nav-item'>
          <a
            className={tab === Tab.Term ? 'nav-link active' : 'nav-link'}
            onClick={(e) => {
              setTab(Tab.Term);
            }}
            href='#2'
          >
            Term
          </a>
        </li>
      </ul>

      <div style={{ marginTop: '20px' }}>
        <FOSTable
          columns={columns}
          data={fixtures}
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={page}
          perPage={perPage}
          totalPage={totalPages}
          initialSortBy={sortBy}
          onChangeSort={setSortBy}
        ></FOSTable>
      </div>
    </div>
  );
};
